import { chain, disable, enable } from '@leprecoins/effector';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { debounce } from 'patronum';
import { gameModel } from 'entities/game';
import { breakpoints, createModalSwitcher } from 'shared/lib';
import { NAVIGATION_IDS, NavigationIds } from '../config';

const switcher = createModalSwitcher();

const $navigationIds = breakpoints.sm.$matches.map((matches) =>
	Object.values(NAVIGATION_IDS).filter(
		(id) =>
			id !== (matches ? NAVIGATION_IDS.BET_CALCULATOR : NAVIGATION_IDS.FAST_BETS_AND_X2_TOGGLE),
	),
);

const $scrollCanChecked = createStore(true);

const $currentId = createStore(NAVIGATION_IDS.HOW_TO_PLAY);

const startOnboarding = createEvent();

const changeCurrentId = createEvent<NavigationIds>();

const autoChangeCurrentId = createEvent<NavigationIds>();

const clearHashFx = createEffect(() => {
	window.location.hash = '';
});

chain(switcher.disable, clearHashFx);

chain(switcher.disable, $currentId.reinit);

chain(changeCurrentId, $currentId);

sample({
	clock: startOnboarding,
	fn: () => true,
	target: [gameModel.$onboardingStep.reinit, gameModel.$isOnboarding],
});

chain(autoChangeCurrentId, $currentId);

disable(changeCurrentId, $scrollCanChecked);

enable(debounce(changeCurrentId, 1000), $scrollCanChecked);

export const gameHelpModalModel = {
	switcher,
	$currentId,
	$navigationIds,
	$scrollCanChecked,
	changeCurrentId,
	autoChangeCurrentId,
	startOnboarding,
};
